/**
 * @enum {string}
 */
const DistanceUnit = {
    Meter: 'Meter',
    Feet: 'Feet',
    Kilometer: 'Kilometer',
    Mile: 'Mile',
    UsSurveyFeet: 'UsSurveyFeet',
    Yard: 'Yard',
    NauticalMile: 'NauticalMile',
    Inch: 'Inch',
    Link: 'Link',
    Chain: 'Chain',
    Pole: 'Pole',
    Rod: 'Rod',
    Furlong: 'Furlong',
    Vara: 'Vara',
    Arpent: 'Arpent',
};
Object.freeze(DistanceUnit);
export default DistanceUnit;